import { fabric } from "fabric";

/**
 * Selection state, text/opacity visibility toggles and the bridge that keeps
 * Fabric selection in sync with the Vue annotation models. Mixed into
 * BboxCanvas.prototype.
 */
export default {
    syncSelectionFromModels(annotations) {
        if (this.canvas && this.canvas._currentTransform) {
            return;
        }
        const selectedIds = new Set(
            annotations.filter((a) => a.selected).map((a) => String(a.id)),
        );
        this.canvas.getObjects().forEach((obj) => {
            if (!obj.annotation_id || obj.text_box) {
                return;
            }
            if (obj.annotation) {
                obj.annotation.selected = selectedIds.has(String(obj.annotation_id));
            }
        });
        const selected = annotations.filter((a) => a.selected);
        if (selected.length > 0) {
            this.hideText();
            this.selectAllAnnotations(selected);
        } else {
            this.showText();
            // Do not discard Fabric selection when Vue is briefly out of sync — that
            // breaks resize handles. Fabric selection:cleared still drives real deselect.
        }
        this._updateBackgroundImageEvented();
    },

    deleteAnnotation(annotation) {
        let objects = this.canvas.getObjects();

        for (let i = 1; i < objects.length; i++) {
            let bbox = objects[i];
            if (bbox.annotation_id === annotation.id) {
                this.deleteObject(false, bbox);
            }
        }
    },

    hideText() {
        let objects = this.canvas.getObjects();

        for (let i = 1; i < objects.length; i++) {
            let bbox = objects[i];

            // Check if bbox is a valid Fabric.js object
            if (!bbox || typeof bbox.set !== 'function') {
                continue;
            }

            try {
                if(bbox.is_point) {
                    bbox.set('opacity', 0.3);
                    if (bbox.text && typeof bbox.text.set === 'function') {
                        bbox.text.set('opacity', 0.0);
                    }
                }
                else if(!bbox.text_box && bbox.annotation && bbox.annotation.selected) {
                    bbox.set('opacity', 0.9);
                    if (bbox.text && typeof bbox.text.set === 'function') {
                        bbox.text.set('opacity', 0.9);
                    }
                }
                else {
                    bbox.set('opacity', 0.4);
                    if(!bbox.text_box && bbox.text && typeof bbox.text.set === 'function') {
                        bbox.set('opacity', 0.4);
                        bbox.text.set('opacity', 0.0);
                    }
                }
            } catch (error) {
                console.warn('Error setting opacity on object:', error);
            }
        }

        // this.requestRenderAll();
    },

    showText() {
        let objects = this.canvas.getObjects();

        for (let i = 1; i < objects.length; i++) {

            let bbox = objects[i];

            // Check if bbox is a valid Fabric.js object
            if (!bbox || typeof bbox.set !== 'function') {
                continue;
            }

            try {
                if(bbox.is_point) {
                    bbox.set('opacity', 0.6);
                    if (bbox.text && typeof bbox.text.set === 'function') {
                        bbox.text.set('opacity', 0.0);
                    }
                }
                else {
                    bbox.set('opacity', 0.8);
                }
            } catch (error) {
                console.warn('Error setting opacity on object:', error);
            }
        }

        this.requestRenderAll();
    },

    selectAllAnnotations(annotation_selected) {

        let selected_annotation_ids = annotation_selected.map(a=>{return a.id});

        let objects = this.canvas.getObjects();
        let selected = objects.filter((o) => {
            return selected_annotation_ids.includes(o.annotation_id) && !o.text_box
        })

        if(selected.length > 1) {

            this.in_group_selection = selected;

            this.canvas.discardActiveObject();
            var sel = new fabric.ActiveSelection(selected, {
                canvas: this.canvas,
            });
            this.canvas.setActiveObject(sel);
            this.canvas.requestRenderAll();
        }
        else if(selected.length === 1) {
            if (selected[0].annotation) {
                selected[0].annotation.selected = true;
            }
            this.ensureDeleteControlOnObject(selected[0]);
            selected[0].setCoords();
            this.canvas.setActiveObject(selected[0]);
            this.canvas.requestRenderAll();
        }

        this.in_group_selection = []
        this._updateBackgroundImageEvented();
    },

    selectAnnotation(annotationId) {
        if(!annotationId) {
            return;
        }
        let objects = this.canvas.getObjects();
        for(let i=0; i<objects.length; i++) {
            if(objects[i].text_box !== true && objects[i].annotation_id === annotationId ) {
                if (objects[i].annotation) {
                    objects[i].annotation.selected = true;
                }
                this.ensureDeleteControlOnObject(objects[i]);
                objects[i].setCoords();
                this.canvas.setActiveObject(objects[i]);
                this.requestRenderAll();
                this._updateBackgroundImageEvented();
                return;
            }
        }
    },

    getAnnotations() {
        let objects = this.canvas.getObjects();
        let annotations = [];
        objects.forEach(object=>{
            if(object.annotation) {
                annotations.push(object.annotation);
            }
        })
        return annotations;
    },
};
